import { all } from 'redux-saga/effects';
import { takeStreamFetch } from '@wix/da-shared-react/pkg/Stream/helpers';
import {
  fetchNextFolderDeviations,
  fetchNextGallectionSearchResults,
} from '../../actions/gallectionSection';
import fetchMoreFolderDeviations from './fetchMoreFolderDeviations';
import fetchMoreGallectionSearchResults from './fetchMoreGallectionSearchResults';

export default function* rootGallectionStreamSagas() {
  yield all([
    takeStreamFetch(fetchNextFolderDeviations, fetchMoreFolderDeviations),
    takeStreamFetch(fetchNextGallectionSearchResults, fetchMoreGallectionSearchResults),
  ]);
}
